
import Carousel from "../../components/Carousel";
import { Typography,Box, Card, CardActionArea, CardMedia, CardContent, CardActions, Button } from "@mui/material";
import { vrImages, whatWeDo, whoWeAre, whyChooseUs } from "../../assets/Json/homePageData";
import aboutImg from "../../assets/images/About_us.jpg"
import ProductCarousel from "../../components/ProductCarousel";
import ReactPanallumVr from "../../components/ReactPanallumVr";
import { Link } from "react-router";
import { useEffect, useRef, useState } from "react";
import ImageLoading from "../../components/LoadingComponent/ImageLoading";
import { useSelector } from "react-redux";
import Seo from "../../components/Seo/Seo";


const Home = () => {
 const { carousels } = useSelector((state) => state.carousels);
  const [allImagesLoaded, setAllImagesLoaded] = useState(false);
  const imageRefs = useRef([]);
  const loadedSet = useRef(new Set());

  const handleImgLoad = (idx) => {
    if (!loadedSet.current.has(idx)) {
      loadedSet.current.add(idx);
      if (loadedSet.current.size === carousels.length) {
        setAllImagesLoaded(true);
      }
    }
  };

  useEffect(() => {
    loadedSet.current.clear();
    setAllImagesLoaded(false);
    imageRefs.current = [];

    carousels.forEach((_, idx) => {
      const img = imageRefs.current[idx];
      if (img && img.complete) {
        handleImgLoad(idx);
      }
    });
  }, [carousels]);

  if (!allImagesLoaded) {
    return (
      <div style={{ textAlign: "center", padding: "3rem", height: "100vh" }}>
        <Seo
          title="JB Architects & Engineers | Best Architects in Tirunelveli"
          description="JB Architects & Engineers is a top-rated architectural firm in Tirunelveli and Palayamkottai offering residential architecture, commercial building design, interior design, 3D elevation and structural engineering services."
          keywords={[
            "architects in tirunelveli",
            "best architectural firm in tirunelveli",
            "architects in palayamkottai",
            "civil engineers and architects in tirunelveli",
            "top house designers in tirunelveli",
          ]}
          path="/"
        />
        <div style={{ display: "none" }}>
          {carousels.map((item, idx) => (
            <img
              key={idx}
              src={item.image}
              ref={(el) => (imageRefs.current[idx] = el)}
              onLoad={() => handleImgLoad(idx)}
              alt=""
            />
          ))}
        </div>
        <ImageLoading img={false} />
      </div>
    );
  }


  return (
    <>
      <Seo
        title="JB Architects & Engineers | Best Architects in Tirunelveli"
        description="JB Architects & Engineers is a top-rated architectural firm in Tirunelveli and Palayamkottai offering residential architecture, commercial building design, interior design, 3D elevation and structural engineering services."
        keywords={[
          "architects in tirunelveli",
          "best architectural firm in tirunelveli",
          "architects in palayamkottai",
          "civil engineers and architects in tirunelveli",
          "top house designers in tirunelveli",
          "residential architects in tirunelveli",
          "commercial building designers in tirunelveli",
        ]}
        path="/"
      />
      <h1 className="visually-hidden">
        JB Architects &amp; Engineers | Best Architects in Tirunelveli &amp; Palayamkottai
      </h1>
      <Carousel data={carousels}/>
      <Box sx={{ padding: "3%"}}>
        <div className="row">
          <div className="col-md-7">
            <div className="container px-4">
              <Typography variant="h5" color="orange" padding="10px">
                About Us
              </Typography>
              <Typography>
                J B Architects & Engineers – Innovating Spaces, Transforming Lives
              </Typography>
              <Typography className="mt-2">
                 At J B Architects & Engineers, we believe that architecture is more than just constructing buildings—it’s about creating experiences, shaping lifestyles, and designing spaces that inspire. With over five years of expertise, we specialize in delivering architectural design, space planning, interior solutions, and structural coordination that seamlessly blend functionality, aesthetics, and practicality.
              </Typography>
              <Typography className="mt-2">
                 Whether it’s a modern residential home, a luxurious villa, a contemporary office, or a commercial project, we craft designs that enhance livability, comfort, and efficiency.
              </Typography>
              <br/>
              <h6>Who We Are</h6>
              <Typography className="mt-2">
                    J B Architects & Engineers is a leading architectural firm dedicated to providing innovative, efficient, and detail-oriented designs. Our team of skilled architects, designers, and engineers work collaboratively to turn your vision into reality. From concept development to final execution, we ensure a seamless and stress-free process while maintaining the highest standards of quality and precision.
              </Typography>
              <Typography className="mt-2">
                    We understand that every space is unique, and that’s why we prioritize personalized design solutions tailored to your specific needs, lifestyle, and functional requirements. Our approach integrates creative design thinking with technical expertise to produce structures that are not only visually stunning but also highly practical.
              </Typography>
       
              <br/>
              <h6>Our Expertise</h6>
              <Typography className="mt-2">
              We offer a comprehensive range of architectural and interior design services, ensuring that every project is executed with perfection and precision:
              </Typography>
              <Typography className="mt-2">
                    <ul>
                      <li>Architectural Design – Custom home designs, modern commercial buildings, and innovative layouts tailored to your needs.</li>
                      <li>Space Planning – Optimized layouts, ergonomic designs, and strategic space utilization for better efficiency and aesthetics.</li>
                      <li>Structural Coordination – Seamless integration of architecture and engineering for durable, safe, and efficient structures.</li>
                      <li>Interior Design – Creating stylish, comfortable, and contemporary interiors that elevate your space.</li>
                      <li>Project Consultation – Expert guidance from design conceptualization to execution, ensuring a smooth and hassle-free process.</li>
                    </ul>
              </Typography>
              <Typography className="mt-2">
                    Let’s Build Your Dream Space!
              </Typography>
              <Typography className="mt-2">
                    At J B Architects & Engineers, we don’t just design buildings—we create inspiring, efficient, and elegant spaces that align with your vision. Whether you're planning a dream home, a functional office space, or a high-end commercial project, we bring expertise, creativity, and precision to every project.
              </Typography>
              <Typography className="mt-2">
              📞 Contact us today to transform your ideas into a masterpiece!
              </Typography>
              {/* <LoadingSpinner/> */}
            </div>
          </div>
          <div className="col-md-5 p-2">
            <img
              style={{ maxWidth: "100%" }}
              src={aboutImg}
              alt="jb architects and engineers tirunelveli"
            />
          </div>
        </div>
      </Box>
      
      {/* <Box sx={{ padding: "3%" }}>
        <Typography variant="h5" color="orange" textAlign="center" >
             What We Do
        </Typography>
      
      <div className="row gy-4 gy-xl-0">
        {whatWeDo?.map((data,idx) => {
          return(
            <div key={idx} className="col-12 col-sm-6 col-xl-4 text-center mt-4">
              <Card  sx={{ maxWidth: "100%",height:"100%" }}>
                <CardContent >
                  <img src={data.img} height='56'/>
                  <h4 className="mb-4 mt-4"> {data?.name} </h4>
                  <p className="mb-4 text-secondary">{data?.content}</p>
                
                </CardContent>
              </Card>
            </div>
          )
        })}
      </div>
         
     
      </Box> */}
      <Box sx={{ padding: "3%" }}>
        <Typography variant="h5" color="orange" textAlign="center" >
            Why Choose Us?
        </Typography>
        <div className="row">
          {
            whyChooseUs.map((data,idx)=>{
              return(
                <div key={idx} className="col-md-3 pt-4">
                  <Card sx={{ maxWidth: "100%",height:"100%" }}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        // height="140"
                        image={data.img}
                        alt="green iguana"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                          {data.name}
                        </Typography>
                        <Typography variant="body2" sx={{ color: "text.secondary" }}>
                          {data.content}
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                    {/* <CardActions>
                      <Button size="small" color="primary">
                        Share
                      </Button>
                    </CardActions> */}
                  </Card>
                </div>
              )
            })
          }
         
        </div>
      </Box>
      <Box sx={{ padding: "3%" }}>
         
         <Typography variant="h5" color="orange" textAlign="center" >
             VR 360 Images
         </Typography>
         <div className="row p-4">
            <div className="col-md-6">
                    <Box 
                       sx={{padding:"10px"}}
                       > 
                        <ReactPanallumVr image={vrImages[0]} idx={0}/>
                    </Box>
            </div>
            <div className="col-md-6">
                      <h6>Experience Architecture in 360°</h6>
                      <p>Step inside our designs like never before! Immerse yourself in a 360° virtual reality experience that brings our architectural concepts to life.</p>
                      <ul style={{lineHeight:"30px"}}>
                        <li><b>See Every Detail:</b>  Experience the materials, textures, lighting, and spatial flow as if you're already there.</li>
                        <li><b>Explore Spaces Virtually:</b> Walk through your future home, office, or commercial space before construction even begins.</li>
                        <li><b>Interactive Design Reviews:</b>Collaborate and make informed decisions with a fully immersive view of your project.</li>
                      </ul>  
                      <Link sx={{
                        
                 backgroundColor: '#121212',
                 color:"white"
                      }} className="btn btn-secondary" to={"/vr-360"}> Explore 360 </Link>          
            </div>

         </div>
       
       </Box>
       
      <Box sx={{ padding: "3%" }}>
         
         <Typography variant="h5" color="orange" textAlign="center" >
             Google Reviews
         </Typography>
          <ProductCarousel /> 
       </Box>
    </>
  );
};

export default Home;
